import { createApp } from 'vue';
import GlobalBreadcrumb from './GlobalBreadcrumb.vue';
import '@coloplast/design-system/dist/components/breadcrumb/ds-breadcrumb.css';
import '@coloplast/design-system/dist/components/tooltip/ds-tooltip.css';
import './GlobalBreadcrumb.scss';

function globalBreadcrumbMount() {
    const globalBreadcrumbMount = document.querySelector('[data-feature="global-breadcrumb"]');

    if (!globalBreadcrumbMount) {
        console.warn('[global-breadcrumb] Container not found');
        return;
    }

    const app = createApp({
        name: 'GlobalBreadcrumbApp',
    });

    app.component('global-breadcrumb', GlobalBreadcrumb);
    app.mount(globalBreadcrumbMount);
}

globalBreadcrumbMount();
